/**
* State model declaration for store vehicle details
**/
export interface ApiResponseState {
  wifiSubscription: object;
  wifiState: object;
  packageSubscription: object;
  subscriptionComplete: boolean;
  vinlist: Array<object>;
  customer: object;
  remoteCustomer: object;
  subscriptionHistoryCustomer: object;
  findVehicle: object;
  apiAction: string;
  preview: object;
  subscribedCustomer: object;
  remoteCommand: object;
  verifyAddress: object;
  getProvisioning: object;
  retrigerProvisioning: object;
  subscriptionHistory: object;
  customerHistory: object;
  tciReport: object;
  sxmReport: object;
  telematicsReport: object;
  apiResponse: object;
  updateEmergencyContact: Object;
  emergencyContact: Object;
  cmsCreateTicketResponse: object;
  tssResponse: object;
  partialFactoryDataFeed: Object;
  fullFactoryDataFeed: Object;
  airDataFeed: Object;
  zuoraResponse: object;
  userRole: object;
  userRoleUpdate: object;
  phoneConfigResponse: object;
  phoneCompatibilitiesResponse: object;
  guidStatus: object;
  homeDealer: object;
  preferredDealer: object;
  outageBanner: object;
  vehicleHistory: object;
  productPackages: object;
  trialLengthsResponse: object;
  vcmTokenResponse: object;
  vcmHistoryResponse: object;
  vcmClearResponse: object;
  vcmBlacklistResponse: object;
  vcmClearChipIdResponse: object;
  userProfileSettings: object;
  lookupKeys: object;
  GoodwillPackagesApiResponse: object;
  submitGoodwillPackagesApiResponse: object;
  dataConsentsResponse: object;
  userDelete: object;
  updateRemoteUser: object;
  survivorAccount: object;
  setPncStatus: object;
}
/**
* Initial State model for store vehicle details
**/
export const initialApiResponseState: ApiResponseState = {
  apiAction: '',
  packageSubscription: {},
  wifiSubscription: {},
  wifiState: {},
  subscriptionComplete: false,
  vinlist: [],
  customer: {},
  remoteCustomer: {},
  subscriptionHistoryCustomer: {},
  findVehicle: {},
  preview: {},
  subscribedCustomer: {},
  remoteCommand: {},
  verifyAddress: {},
  getProvisioning: {},
  retrigerProvisioning: {},
  subscriptionHistory: {},
  customerHistory: {},
  tciReport: {},
  sxmReport: {},
  telematicsReport: {},
  updateEmergencyContact: {},
  emergencyContact: {},
  cmsCreateTicketResponse: {},
  tssResponse: {},
  partialFactoryDataFeed: {},
  fullFactoryDataFeed: {},
  airDataFeed: {},
  apiResponse: {},
  zuoraResponse: {},
  userRole: {},
  userRoleUpdate: {},
  phoneConfigResponse: {},
  phoneCompatibilitiesResponse: {},
  guidStatus: {},
  homeDealer: {},
  preferredDealer: {},
  outageBanner: {},
  vehicleHistory: {},
  productPackages: {},
  trialLengthsResponse: {},
  vcmTokenResponse: {},
  vcmHistoryResponse: {},
  vcmClearResponse: {},
  vcmBlacklistResponse: {},
  vcmClearChipIdResponse: {},
  userProfileSettings: {},
  lookupKeys: {},
  GoodwillPackagesApiResponse: {},
  submitGoodwillPackagesApiResponse: {},
  dataConsentsResponse: {},
  userDelete: {},
  updateRemoteUser: {},
  survivorAccount: {},
  setPncStatus: {},
};
